import {createSlice} from "@reduxjs/toolkit";

const initialEndsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  endForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const endsSlice = createSlice({
  name: "ends",
    initialState: initialEndsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getEndById
    endFetched: (state, action) => {
      state.actionsLoading = false;
      state.endForEdit = action.payload.endForEdit;
      state.error = null;
    },
    // findEnds
    endsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createEnd
    endCreated: (state, action) => {
        state.actionsLoading = false;
      state.error = null;
        state.entities.push(action.payload.model);
        state.totalCount++;
    },
    // updateEnd
    endUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.end.id) {
            return action.payload.end;
        }
        return entity;
      });
    },
    // deleteEnd
    endDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteEnds
    endsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
  }
});
